<template>
  <withTopNav :leftText="t('Activities.Bonus.History')" class="bonusHistory" fixed>
    <div class="main py-6">
      <div class="flex-center-x bd-b-[1px_var(--theme-primary)] h-8.5 px-4">
        <span
          v-for="tab, i in tabs" :key="tab.name"
          @click="changeTab(i)"
          class="text-15 text-white/75 text-center flex-1 leading-32 font-[600]"
          :class="{'!text-[var(--theme-text-dark)] bg-[var(--theme-primary)] rounded-t-8': activeIndex === i}">
          {{ tab.title }}
        </span>
      </div>

      <NoData v-if="curListData?.total == 0" class="mt-15" />
      <van-list
        v-else
        v-model:loading="loading"
        :loading-text="$t('Common.Loading')"
        :finished="curListData?.finished"
        finished-text=""
        :immediate-check="false"
        @load="loadData"
      >
        <ListItem @success="reset" :type="curType" :item :status="curStatus" v-for="item, i in curListData?.list" :key="i" />
      </van-list>
    </div>
  </withTopNav>
</template>
<script setup lang="ts">
  import withTopNav from '@/layouts/withTopNav.vue'
  import ListItem from './listItem.vue'
  import { getBonusActivityHistory } from '@/api'
  import type { tStatus, iListData } from '@/types/index'
  import NoData from '@/components/NoData/index.vue'
  import debounce from 'lodash-es/debounce'
  import { useI18n } from 'vue-i18n'
  const { t } = useI18n()

  const tabs = [
    {
      title: t('Activities.Bonus.HistoryTabs.Available'),
      name: 'available',
      key: 'Awarded' as tStatus,
      data: []
    },
    {
      title: t('Activities.Bonus.HistoryTabs.resgated'),
      name: 'resgated',
      key: 'Received' as tStatus,
      data: []
    },
    {
      title: t('Activities.Bonus.HistoryTabs.expired'),
      name: 'expired',
      key: 'Expired' as tStatus,
      data: []
    }
  ]

  const curType: 'bonus' | 'ggc' = 'bonus'
  const pageSize = 30

  const activeIndex = ref(0)
  const listsData = ref<iListData[]>([])
  const curListData = computed(() => listsData.value[activeIndex.value])

  const curStatus = computed(() => tabs[activeIndex.value].key)
  const loading = ref(false);
  const route = useRoute()

  const changeTab = (index: number) => {
    activeIndex.value = index
    listsData.value[index] = {
      total: -1,
      list: [],
      pageIndex: -1,
      finished: false
    }

    loadData()
  }

  const loadData = debounce(async () => {
    if (curListData.value?.finished) return
    loading.value = true

    try {
      const { pageIndex } = curListData.value
      const { code, data } = await getBonusActivityHistory({
        activityId: route.query.activityId as string,
        status: curStatus.value,
        pageIndex: pageIndex + 1,
        pageSize
      })
      if (code === 1 && data) {
        curListData.value.list = [...curListData.value.list, ...data.data]
        curListData.value.total = data.total
        curListData.value.pageIndex = pageIndex + 1
        curListData.value.finished = (pageIndex + 2) * pageSize >= data.total
      }
    } finally {
      loading.value = false
    }
  }, 300)

  const reset = () => {
    showLoadingToast(t('Common.Loading'))

    listsData.value = []
    changeTab(0)
  }

  if (!route.query.activityId) {
    showToast({
      message: t('Activities.Bonus.HistoryTabs.InvalidActivityId'),
      duration: 0,
    })
  } else {
    reset()
  }
</script>

